export const MasaBrand = ({ size = "sm" }) => (
  <div className="flex items-center gap-2.5" data-testid="masa-brand">
    <img src="/masa-mark.png" alt="" className={size === "lg" ? "h-10" : "h-7"} />
    <div className="leading-none">
      <img src="/masa-word.png" alt="MaSa" className={size === "lg" ? "h-8" : "h-5"} />
      <div className={`text-zinc-400 mt-1 ${size === "lg" ? "text-xs" : "text-[9px]"}`}>an AI Agent from Specia AI</div>
    </div>
  </div>
);
